import { NetChip } from '#components/net-chip/net-chip.js';

export interface NetMarkdownItemProps {
	netName?: string;
}

/**
 * Renders a markdown net reference with the same interactive chip used by CAD model views.
 */
export function NetMarkdownItem(props: NetMarkdownItemProps) {
	if (props.netName === undefined) {
		return null;
	}

	return (
		<span className='mx-0.5 inline-flex items-center align-middle isolate'>
			<NetChip net={props.netName} />
		</span>
	);
}
